import React from 'react';

const Button = ({
  variant = 'primary',
  size = '',
  block = false,
  loading = false,
  disabled = false,
  onClick,
  type = 'button',
  children,
  className = ''
}) => {
  const variantClass = `btn-${variant}`;
  const sizeClass = size ? `btn-${size}` : '';
  const blockClass = block ? 'btn-block' : '';

  return (
    <button
      type={type}
      className={`btn ${variantClass} ${sizeClass} ${blockClass} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <span className="btn-loader" />}
      {!loading && children}
      {loading && <span>Processing</span>}
    </button>
  );
};

export default Button;
